<template>
  <div>
    <h-input label="Question" v-model="question.question" />
    <v-checkbox label="Always Ask" v-model="question.always" />
    <label>How do you want this question to be graphed?</label>
    <h-btn @click="save">Save And Add Another Question</h-btn>
    <h-btn>Save And Go To the next step</h-btn>
    <h-btn>Next Step</h-btn>
  </div>
</template>

<script>
export default {
  data() {
    return {
      question: {}
    };
  },
  methods: {
    save() {
      this.$emit("saved", this.question);
      this.question = {};
    }
  }
};
</script>

<style>
</style>
